$(document).ready(() => {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof (iframe) == 'object') && !(typeof (iframeId) == 'object')) {
      App.cable.disconnect();
      $("#subscription-step-2-success").addClass('d-none');
      $("#subscription-step-2-failure").removeClass('d-none');
    }
  };

  function generateUniversignIframe(signerId) {
    const configuration = {};
    const iframeEndpoint = $('#subscription-step-3').data('universign-iframe-endpoint');
    /**
    * The universignSigInit function add an iframe element as child of element with
    * id attribute equals to containerId parameter, the attribute src is set from
    * the universignUrl variable, it is the url of the website to be integrated in
    * the iframe, the width and height of the iframe will take 100% of its
    * container.
    *
    * @param {string} containerId The id of the element in which we will inject
    * the iframe.
    * @param {string} signerId The identifier of transaction.
    * @param {object} configuration The options list to customize the iframe:
    * * redirectionMode {string} This params have two possible values: IN or OUT,
    * the dafault value is OUT,
    * if the value of this params is equal to OUT the redirection will be done
    * outside the iframe(in website container of the iframe),
    * if the value of this params is equal to ÌN the redirection will be done
    * inside the iframe,
    * if the value of this params is otherwise, an exception will be triggered.
    **/

    universignSigInit('subscription-step-3', signerId, configuration, iframeEndpoint);
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.src = documentUrl;

    $('#subscription-step-3').prepend(iframe);

    $('.edit_subscription').on('ajax:success', function(event) {
      $('#subscription-step-3').addClass('d-none');
      $('#subscription-step-4').removeClass('d-none');
      $('.breadcrumb-element:nth-child(3)').removeClass('current');
      $('.breadcrumb-element:nth-child(3)').addClass('past');
      $('.breadcrumb-element:nth-child(4)').removeClass('next');
      $('.breadcrumb-element:nth-child(4)').addClass('current');
      $('#completion').text('Étape 4/4');
    });
  }

  setTimeout(docliftDoesNotAnswer, 180000);

  if ($('#signature-subscription-id').length) {
    App.cable.subscriptions.create(
      { channel: "SignatureChannel", subscription_id: $('#signature-subscription-id').data('id') }, {
        received(data) {
          try {
            if (data.status == 'success') {
              if (data.e_sign_id !== undefined) {
                generateUniversignIframe(data.e_sign_id);
              } else {
                generateContractIframe(data.document_url)
              }
              $('#contract-loaded-button').prop('disabled', false);
              $('#contract-loaded-button').removeClass('btn-description');
              $('#contract-loaded-button #contractLoading').addClass('d-none');
              $('#contract-loaded-button #contractReady').removeClass('d-none');
              $('#generating_doc_explanations').addClass('d-none');
              $('#generating_doc_ready').removeClass('d-none');
              $('#contract-loading-icon').addClass('d-none');
              $('#contract-loaded-button').removeClass('btn-secondary');
              $('#contract-loaded-button').addClass('btn-primary');

              $('#contract-loaded-button').on('click', (e) => {
                $('#subscription-step-3').removeClass('d-none');

                $('#subscription-step-2-success').addClass('d-none');

                $('.breadcrumb-element:nth-child(2)').removeClass('current');
                $('.breadcrumb-element:nth-child(2)').addClass('past');
                $('.breadcrumb-element:nth-child(3)').removeClass('next');
                $('.breadcrumb-element:nth-child(3)').addClass('current');
                $('#completion').text('Étape 3/4');
              });
            } else {
              setTimeout(() => {
                $('#subscription-step-2-success').addClass('d-none');
                $('#subscription-step-3').addClass('d-none');
                $('#subscription-step-4').addClass('d-none');
                $('#subscription-step-3-error').removeClass('d-none');
              }, 5000);
            }
          } catch {
            setTimeout(() => {
              $('#subscription-step-2-success').addClass('d-none');
              $('#subscription-step-3').addClass('d-none');
              $('#subscription-step-4').addClass('d-none');
              $('#subscription-step-3-error').removeClass('d-none');
            }, 5000);
          }
        },
        rejected() {
          setTimeout(() => {
            $('#subscription-step-2-success').addClass('d-none');
            $('#subscription-step-3').addClass('d-none');
            $('#subscription-step-4').addClass('d-none');
            $('#subscription-step-3-error').removeClass('d-none');
          }, 5000);
          this.uninstall();
        },
      }
    );
  };
});
